/** Auth page copy. EN mirrors SV until proper translations are added. */
export const authTranslationsSv = {
    signIn: {
        helmetTitle: 'Logga in',
        disabledUser: 'Användaren har inaktiverats. Vänligen kontakta info@financelab.se för mer information.',
        incorrectUsernameOrPassword: 'Ogiltigt användarnamn eller lösenord.',
    },
    resetPassword: {
        helmetTitle: 'Glömt lösenord',
        title: 'Glömt lösenord',
        prompt: 'Skriv in din epostadress för att återställa ditt lösenord',
    },
    resetPasswordWithCode: {
        helmetTitle: 'Glömt lösenord',
        title: 'Återställ lösenord',
        infoMessage:
            'Om den angivna användaren finns hos oss så får du en återställningskod till din e-postadress. Ange den här tillsammans med ditt nya lösenord.',
        infoMessageContactPrefix:
            'Om du inte får någon e-post kan det bero på att du angivit fel e-postadress eller att din användare är inaktiverad. Kontakta ',
        infoMessageContactSuffix: ' om du tror du tror att det kan vara fallet.',
        successMessage: 'Lösenordet har återställts. Du kan nu',
        signInLink: 'logga in',
        requestNewCode: 'Begär ny kod',
        submit: 'Återställ lösenord',
        fields: {
            email: 'Epostadress',
            code: 'Återställningskod',
            newPassword: 'Nytt lösenord',
            confirmPassword: 'Bekräfta nytt lösenord',
        },
        validation: {
            emailInvalid: 'Måste vara en giltig epostadress',
            emailRequired: 'Epostadress måste anges',
            codeRequired: 'Återställningskod måste anges',
            passwordMinLength: 'Lösenordet måste innehålla minst 10 tecken',
            passwordRequired: 'Nytt lösenord måste anges',
            passwordsMismatch: 'Lösenorden matchar inte',
            confirmRequired: 'Bekräfta lösenordet',
        },
        errors: {
            invalidCode: 'Ogiltig kod eller fel vid återställning',
        },
    },
    profile: {
        helmetTitle: 'Användarprofil',
        title: 'Användarprofil',
        changePassword: {
            title: 'Byt lösenord',
            submit: 'Byt lösenord',
            submitting: 'Byter...',
            currentPassword: 'Nuvarande lösenord',
            newPassword: 'Nytt lösenord',
            newPasswordAgain: 'Nytt lösenord (igen)',
            success: 'Lösenordet är uppdaterat',
            updateFailed: 'Kunde inte uppdatera lösenordet. Försök igen.',
            wrongCurrentPassword: 'Felaktigt nuvarande lösenord',
            invalidNewPassword: 'Ej tillåtet nytt lösenord',
            validation: {
                fieldRequired: 'Fältet är obligatoriskt',
                passwordPattern:
                    'Lösenordet måste innehålla minst 10 tecken, en stor bokstav, en liten bokstav och en siffra',
                passwordsMismatch: 'Lösenorden matchar inte',
            },
        },
    },
}
